import { JsonModel, Model } from './model'

export class SupplierBrand extends Model {
    id: number
    name: string

    constructor(json: JsonSupplierBrand) {
        super(json)

        this.id = json.id
        this.name = json.name
    }
}

export interface JsonSupplierBrand extends JsonModel {
    id: number
    name: string
}
